import { TextField, textFieldClasses } from "@mui/material";
import { styled } from "@mui/material/styles";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import { useEffect, useState } from "react";

type DateFieldProps = {
  value: any;
  onChange: (e: any) => void;
  placeholder: string;
  format?: string;
  minDate?: any;
  maxDate?: any;
  onError?: (newError: any) => void;
  disabled?: boolean;
  disableFuture?: boolean;
};

const StyledTextField = styled(TextField)(() => ({
  backgroundColor: "#ffffff",
  borderRadius: 28,
  fontSize: 14,
  height: 40,
  minHeight: 36,

  [`& .${textFieldClasses.root}`]: {
    borderRadius: 28,
  },

  [`& .MuiOutlinedInput-root`]: {
    borderRadius: 28,
    "& fieldset": {
      borderColor: "#767676",
    },
    "&:hover fieldset": {
      borderColor: "#E20074",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#E20074",
    },
    "& input": {
      padding: "8px 12px",
      fontSize: 12,
      color: "#434343",
      fontWeight: 400,
      "&::placeholder": {
        color: "#434343",
        fontWeight: 400,
        opacity: 1,
      },
    },
  },
}));

export default function DateField({
  value,
  onChange,
  placeholder,
  format,
  minDate,
  maxDate,
  onError,
  disabled = false,
  disableFuture = false,
}: DateFieldProps) {
  const [localValue, setLocalValue] = useState<any>(value ?? null);

  useEffect(() => {
    const incoming = value ?? null;
    const isDifferent =
      (!!localValue && !!incoming && !dayjs(localValue).isSame(incoming, "day")) ||
      (!!localValue && !incoming) ||
      (!localValue && !!incoming);
    if (isDifferent) {
      setLocalValue(incoming);
    }
  }, [value, localValue]);

  return (
    <DatePicker
      disabled={disabled}
      value={localValue}
      onChange={(e) => {
        setLocalValue(e);
        onChange(e);
      }}
      views={["year", "month", "day"]}
      format={format ?? "DD/MM/YYYY"}
      minDate={minDate ?? dayjs("1900-01-01")}
      maxDate={maxDate ?? dayjs("2100-12-31")}
      showDaysOutsideCurrentMonth
      enableAccessibleFieldDOMStructure={false}
      disableFuture={disableFuture}
      slots={{ textField: StyledTextField }}
      slotProps={{
        textField: {
          placeholder,
        },
      }}
      onError={onError}
      sx={{
        width: "100%",
        backgroundColor: "unset",
        alignItems: "flex-start",
      }}
    />
  );
}
